import type { VisitedStepsState } from './visitedSteps.types';

import type { RootState } from '~/redux/store';

export const selectVisitedSteps = ({
  visitedSteps,
}: RootState): VisitedStepsState['visitedSteps'] => visitedSteps.visitedSteps;
